import { ALL_MESSAGES_ADD, ALL_MESSAGES_FAIL, ALL_MESSAGES_REQUEST, ALL_MESSAGES_SUCCESS, CLEAR_ERRORS, MESSAGES_SEEN_UPDATE, MESSAGE_SEEN_UPDATE, NEW_MESSAGE_FAIL, NEW_MESSAGE_REQUEST, NEW_MESSAGE_RESET, NEW_MESSAGE_SUCCESS } from "../constants/messageConstants";

export const allMessagesReducer = (state = { messages: [] }, { type, payload }) => {
    switch (type) {
        case ALL_MESSAGES_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ALL_MESSAGES_SUCCESS: {
            // Merge server messages with any locally-added socket messages.
            // Keep all server messages, and append any local-only ones (no _id yet).
            const serverIds = new Set(payload.map((m) => m._id));
            // Local messages that haven't been persisted yet (no _id or temporary id)
            const localOnly = state.messages.filter(
                (m) => !m._id || !serverIds.has(m._id)
            );
            return {
                loading: false,
                messages: [...payload, ...localOnly],
            };
        }
        case ALL_MESSAGES_FAIL:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case ALL_MESSAGES_ADD:
            // Avoid duplicates when adding a new message
            if (state.messages.some((m) => m._id && m._id === payload._id)) {
                return state;
            }
            return {
                ...state,
                messages: [...state.messages, payload],
            };
        case MESSAGES_SEEN_UPDATE:
            // Mark all own messages as 'read' — receiver has opened and seen them
            return {
                ...state,
                messages: state.messages.map((m) =>
                    m.status !== 'read' ? { ...m, status: 'read' } : m
                ),
            };
        case MESSAGE_SEEN_UPDATE:
            // Mark a single message as 'read'
            return {
                ...state,
                messages: state.messages.map((m) =>
                    m._id === payload.messageId ? { ...m, status: 'read' } : m
                ),
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
}

export const newMessageReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case NEW_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case NEW_MESSAGE_SUCCESS:
            return {
                loading: false,
                success: payload.success,
                newMessage: payload.newMessage,
            };
        case NEW_MESSAGE_RESET:
            return {
                ...state,
                success: false,
                newMessage: {}
            };
        case NEW_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
}